export const ndcAPIs = [
  "ndcAirshoppingQuery",
  "ndcOfferPriceQuery",
  "ndcOrderRetrieve1Query",
  "ndcOrderCreateMutation",
  "ndcOrderQuoteQuery",
  "ndcOrderChangePaymentMutation",
  "ndcOrderChangeMutation",
  "ndcCancelReshopQuery",
  "ndcairshoppingReshopQuery",
  "ndcOfferReshopQuery",
  "SeatMapQuery",
  "ServiceListQuery",
  "ndcOfferReshopQuoteQuery",
  "ndcSeatMapOrderQuoteQuery",
  "ndcOrderQuoteAncillaryQuery",
  "ndcOrderChangeUpdateQueryMutation",
  "ndcOrderChangeUsageQueryMutation",
];
